// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Стили для LayerMenu (LayerMenu.css) */
.layer-menu {
  position: fixed;
  max-height: 85vh;
  width: 290px;
  bottom: 10%;
  right: 1%;

  /* Добавляем для правильного позиционирования призрака при drag&drop */
  isolation: isolate;

  text-align: center;
  background-color: var(--tg-theme-bg-color);
  padding: 3px 3px 3px 3px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.2);
  border-radius: 14px;
  z-index: 1100;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: visible;

  transform: none;
}

.layer-menu-header {
  box-sizing: border-box; /* Ensure padding is included in width calculation */
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 5px;
  padding-left: 30px; 
  padding-right: 3px; 
}

.layer-menu-buttons {
  display: flex;
  gap: 5px; /* Расстояние между кнопками */
}

.layer-menu-title {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: var(--tg-theme-button-color);
  font-size: 24px;
  margin-right: 10px;
}

.new-layer-button {
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  background-color: var(--tg-theme-button-color);
  color: var(--tg-theme-button-text-color);
  border: 0;
  font-size: 20px;
  border-radius: 14px;
  display: flex; /* Добавляем flexbox для центрирования содержимого */
  justify-content: center; /* Центрируем по горизонтали */
  align-items: center; /* Центрируем по вертикали */
  cursor: pointer;
}


.new-layer-button:hover {
  opacity: 0.9;
}

.layer-list {
  width: 98%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: visible;
  overflow-y: auto;
  overflow-x: hidden; /* Отключаем горизонтальную прокрутку */
}

.layer-list * {
  touch-action: pan-y;
}

.layer-row {
  box-sizing: border-box;
  width: 100%;
  margin: 1px auto;
  height: 46px;
  padding: 3px;
  background: none;
  color: var(--tg-theme-text-color);
  cursor: pointer;
  border-radius: 14px;
  background-color: rgba(138, 138, 138, 0.07);
  border: 2px solid transparent;
  opacity: 1;
  transition: transform 0.2s ease, opacity 0.2s ease;
  display: flex;
  align-items: center;
}

.layer-row-column {
  display: flex;
  box-sizing: border-box;
  flex-direction: column; /* Основной контейнер теперь вертикальный */
  align-items: stretch; /* Элементы растягиваются по ширине */
  flex-grow: 1; /* Заставляем .layer-row-column занимать всё доступное пространство */
  min-width: 0; /* Предотвращает растягивание из-за содержимого */
}

.layer-row-main {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between; /* Распределяем пространство: название слева, кнопки справа */
}

.layer-metrics {
  width: 100%;
  margin-top: 0px;
  padding-left: 5px;
  padding-bottom: 0px;
  text-align: left; 
  font-size: 10px; 
  white-space: nowrap; 

  /* overflow: visible;  */
  /* border-top: 1px solid #ccc;  */
}

.layer-row.invisible {
  opacity: 0.4;
}

.layer-row.active {
  background-color: var(--tg-theme-button-color);
  color: var(--tg-theme-button-text-color);
  border: 2px solid transparent;
  opacity: 1;
}

.layer-row.dragging {
  opacity: 0.1;
}

.layer-row.drag-over.drag-over-up {
  border-top: 2px solid var(--tg-theme-button-color);
}

.layer-row.drag-over.drag-over-down {
  border-bottom: 2px solid var(--tg-theme-button-color);
}

.layer-row.ghost {
  opacity: 0.8;
  background-color: var(--tg-theme-bg-color);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  border-radius: 14px;
}

.layer-name {
  flex: 1 1;
  text-align: left;
  padding-left: 10px;
  padding-right: 10px;
}

.layer-control-button {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--tg-theme-button-color);
}
.layer-control-button.active {
  color: var(--tg-theme-button-text-color);
}

.layer-control-icon {
  height: 22px;
  width: 22px;
  margin-left: 3px;
  background: none;
  border: none;
  cursor: pointer;
}

.drag-handle {
  cursor: move;
  padding: 0 4px;
  margin-right: 0px;
  font-size: 18px;
  opacity: 0.5;
  color: var(--tg-theme-text-color);
  touch-action: none; /* Отключаем прокрутку во время перетаскивания */
}

.layer-row:hover .drag-handle {
  opacity: 1;
}

.layer-row:active {
  cursor: grabbing;
}

body.dragging {
  -webkit-user-select: none;
          user-select: none;
}

/* Стили для групп слоев */
.layer-group-row {
  box-sizing: border-box;
  width: 100%;
  margin: 1px auto;
  height: 36px;
  padding: 3px 8px;
  background: none;
  color: var(--tg-theme-text-color);
  cursor: pointer;
  border-radius: 10px;
  background-color: rgba(138, 138, 138, 0.12);
  border: 2px solid transparent;
  opacity: 1;
  transition: transform 0.2s ease, opacity 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

.layer-group-row:hover {
  background-color: rgba(138, 138, 138, 0.18);
}

.layer-group-row.expanded {
  background-color: rgba(138, 138, 138, 0.15);
}

.layer-group-row.invisible {
  opacity: 0.4;
}

.layer-group-row.transform-active {
  background-color: var(--tg-theme-button-color);
  color: var(--tg-theme-button-text-color);
  border: 2px solid transparent;
}

.layer-group-row.transform-active .layer-group-toggle,
.layer-group-row.transform-active .layer-group-label {
  color: var(--tg-theme-button-text-color);
}

.layer-group-row.dragging {
  opacity: 0.1;
}

.layer-group-row.drag-over.drag-over-up {
  border-top: 2px solid var(--tg-theme-button-color);
}

.layer-group-row.drag-over.drag-over-down {
  border-bottom: 2px solid var(--tg-theme-button-color);
}

.layer-group-row.drag-over-group {
  border: 2px dashed var(--tg-theme-button-color);
}

.layer-group-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  font-size: 12px;
  border-radius: 3px;
  color: var(--tg-theme-text-color);
}

.layer-group-label {
  flex: 1 1;
  text-align: left;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.layer-group-label-count {
  font-size: 14px;
  opacity: 0.7;
  font-weight: normal;
}

.layer-drag-handle {
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  color: rgba(138, 138, 138, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 26px;
  touch-action: none; /* Отключаем прокрутку во время перетаскивания */
}

.layer-drag-handle:active {
  cursor: grabbing;
}

.layer-row.in-group {
  margin-left: 15px;
  width: calc(100% - 15px);
}

/* Стили для удаленных элементов */
.layer-row.deleted, .layer-group-row.deleted {
  opacity: 0.6;
  background-color: rgba(255, 100, 100, 0.1);
  border: 1px dashed rgba(255, 100, 100, 0.3);
}

.layer-row.deleted:hover, .layer-group-row.deleted:hover {
  background-color: rgba(255, 100, 100, 0.2);
  opacity: 0.8;
}

/* Стили для зоны удаления */
.delete-zone {
  transition: background-color 0.2s ease, opacity 0.2s ease;
}

.delete-zone.active {
  transform: scale(1.1);
  box-shadow: 0 0 10px rgba(255, 68, 68, 0.5);
}

/* Стили для области разгруппировки */
.ungroup-drop-zone {
  box-sizing: border-box;
  width: 100%;
  height: 10px; /* Половина высоты обычного слоя */
  border: 2px dashed rgba(138, 138, 138, 0.4);
  border-radius: 8px;
  background-color: rgba(138, 138, 138, 0.08);
  color: var(--tg-theme-hint-color);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  opacity: 0;
}

.ungroup-drop-zone.active {
  border: 2px dashed var(--tg-theme-button-color);
  background-color: rgba(var(--tg-theme-button-color-rgb, 138, 138, 138), 0.15);
  color: var(--tg-theme-button-color);
  opacity: 1;
  height: 22px; 
}

.ungroup-zone-text {
  font-size: 11px;
  font-weight: 500;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/menus/layer/LayerMenu.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,SAAS;;EAET,sEAAsE;EACtE,kBAAkB;;EAElB,kBAAkB;EAClB,0CAA0C;EAC1C,wBAAwB;EACxB,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;;EAEjB,eAAe;AACjB;;AAEA;EACE,sBAAsB,EAAE,oDAAoD;EAC5E,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ,EAAE,8BAA8B;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,wCAAwC;EACxC,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,aAAa,EAAE,oDAAoD;EACnE,uBAAuB,EAAE,8BAA8B;EACvD,mBAAmB,EAAE,4BAA4B;EACjD,eAAe;AACjB;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB,EAAE,uCAAuC;AAC7D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,6BAA6B;EAC7B,UAAU;EACV,kDAAkD;EAClD,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB,EAAE,2CAA2C;EACnE,oBAAoB,EAAE,qCAAqC;EAC3D,YAAY,EAAE,qEAAqE;EACnF,YAAY,EAAE,iDAAiD;AACjE;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B,EAAE,6DAA6D;AAC/F;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;;EAEnB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,wCAAwC;EACxC,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,YAAY;EACZ,0CAA0C;EAC1C,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mCAAmC;AACrC;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,kBAAkB,EAAE,gDAAgD;AACtE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,6BAA6B;EAC7B,UAAU;EACV,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAE,gDAAgD;AACtE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,yDAAyD;AAC3D;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,qCAAqC;AACrC;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY,EAAE,kCAAkC;EAChD,2CAA2C;EAC3C,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,+CAA+C;EAC/C,6EAA6E;EAC7E,mCAAmC;EACnC,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;AACtB","sourcesContent":["/* Стили для LayerMenu (LayerMenu.css) */\n.layer-menu {\n  position: fixed;\n  max-height: 85vh;\n  width: 290px;\n  bottom: 10%;\n  right: 1%;\n\n  /* Добавляем для правильного позиционирования призрака при drag&drop */\n  isolation: isolate;\n\n  text-align: center;\n  background-color: var(--tg-theme-bg-color);\n  padding: 3px 3px 3px 3px;\n  box-shadow: 0 3px 10px rgba(0,0,0,0.2);\n  border-radius: 14px;\n  z-index: 1100;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow: visible;\n\n  transform: none;\n}\n\n.layer-menu-header {\n  box-sizing: border-box; /* Ensure padding is included in width calculation */\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin: 5px;\n  padding-left: 30px; \n  padding-right: 3px; \n}\n\n.layer-menu-buttons {\n  display: flex;\n  gap: 5px; /* Расстояние между кнопками */\n}\n\n.layer-menu-title {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  color: var(--tg-theme-button-color);\n  font-size: 24px;\n  margin-right: 10px;\n}\n\n.new-layer-button {\n  box-sizing: border-box;\n  width: 40px;\n  height: 40px;\n  background-color: var(--tg-theme-button-color);\n  color: var(--tg-theme-button-text-color);\n  border: 0;\n  font-size: 20px;\n  border-radius: 14px;\n  display: flex; /* Добавляем flexbox для центрирования содержимого */\n  justify-content: center; /* Центрируем по горизонтали */\n  align-items: center; /* Центрируем по вертикали */\n  cursor: pointer;\n}\n\n\n.new-layer-button:hover {\n  opacity: 0.9;\n}\n\n.layer-list {\n  width: 98%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow: visible;\n  overflow-y: auto;\n  overflow-x: hidden; /* Отключаем горизонтальную прокрутку */\n}\n\n.layer-list * {\n  touch-action: pan-y;\n}\n\n.layer-row {\n  box-sizing: border-box;\n  width: 100%;\n  margin: 1px auto;\n  height: 46px;\n  padding: 3px;\n  background: none;\n  color: var(--tg-theme-text-color);\n  cursor: pointer;\n  border-radius: 14px;\n  background-color: rgba(138, 138, 138, 0.07);\n  border: 2px solid transparent;\n  opacity: 1;\n  transition: transform 0.2s ease, opacity 0.2s ease;\n  display: flex;\n  align-items: center;\n}\n\n.layer-row-column {\n  display: flex;\n  box-sizing: border-box;\n  flex-direction: column; /* Основной контейнер теперь вертикальный */\n  align-items: stretch; /* Элементы растягиваются по ширине */\n  flex-grow: 1; /* Заставляем .layer-row-column занимать всё доступное пространство */\n  min-width: 0; /* Предотвращает растягивание из-за содержимого */\n}\n\n.layer-row-main {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: space-between; /* Распределяем пространство: название слева, кнопки справа */\n}\n\n.layer-metrics {\n  width: 100%;\n  margin-top: 0px;\n  padding-left: 5px;\n  padding-bottom: 0px;\n  text-align: left; \n  font-size: 10px; \n  white-space: nowrap; \n\n  /* overflow: visible;  */\n  /* border-top: 1px solid #ccc;  */\n}\n\n.layer-row.invisible {\n  opacity: 0.4;\n}\n\n.layer-row.active {\n  background-color: var(--tg-theme-button-color);\n  color: var(--tg-theme-button-text-color);\n  border: 2px solid transparent;\n  opacity: 1;\n}\n\n.layer-row.dragging {\n  opacity: 0.1;\n}\n\n.layer-row.drag-over.drag-over-up {\n  border-top: 2px solid var(--tg-theme-button-color);\n}\n\n.layer-row.drag-over.drag-over-down {\n  border-bottom: 2px solid var(--tg-theme-button-color);\n}\n\n.layer-row.ghost {\n  opacity: 0.8;\n  background-color: var(--tg-theme-bg-color);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\n  border-radius: 14px;\n}\n\n.layer-name {\n  flex: 1;\n  text-align: left;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.layer-control-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--tg-theme-button-color);\n}\n.layer-control-button.active {\n  color: var(--tg-theme-button-text-color);\n}\n\n.layer-control-icon {\n  height: 22px;\n  width: 22px;\n  margin-left: 3px;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.drag-handle {\n  cursor: move;\n  padding: 0 4px;\n  margin-right: 0px;\n  font-size: 18px;\n  opacity: 0.5;\n  color: var(--tg-theme-text-color);\n  touch-action: none; /* Отключаем прокрутку во время перетаскивания */\n}\n\n.layer-row:hover .drag-handle {\n  opacity: 1;\n}\n\n.layer-row:active {\n  cursor: grabbing;\n}\n\nbody.dragging {\n  user-select: none;\n}\n\n/* Стили для групп слоев */\n.layer-group-row {\n  box-sizing: border-box;\n  width: 100%;\n  margin: 1px auto;\n  height: 36px;\n  padding: 3px 8px;\n  background: none;\n  color: var(--tg-theme-text-color);\n  cursor: pointer;\n  border-radius: 10px;\n  background-color: rgba(138, 138, 138, 0.12);\n  border: 2px solid transparent;\n  opacity: 1;\n  transition: transform 0.2s ease, opacity 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n}\n\n.layer-group-row:hover {\n  background-color: rgba(138, 138, 138, 0.18);\n}\n\n.layer-group-row.expanded {\n  background-color: rgba(138, 138, 138, 0.15);\n}\n\n.layer-group-row.invisible {\n  opacity: 0.4;\n}\n\n.layer-group-row.transform-active {\n  background-color: var(--tg-theme-button-color);\n  color: var(--tg-theme-button-text-color);\n  border: 2px solid transparent;\n}\n\n.layer-group-row.transform-active .layer-group-toggle,\n.layer-group-row.transform-active .layer-group-label {\n  color: var(--tg-theme-button-text-color);\n}\n\n.layer-group-row.dragging {\n  opacity: 0.1;\n}\n\n.layer-group-row.drag-over.drag-over-up {\n  border-top: 2px solid var(--tg-theme-button-color);\n}\n\n.layer-group-row.drag-over.drag-over-down {\n  border-bottom: 2px solid var(--tg-theme-button-color);\n}\n\n.layer-group-row.drag-over-group {\n  border: 2px dashed var(--tg-theme-button-color);\n}\n\n.layer-group-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  font-size: 12px;\n  border-radius: 3px;\n  color: var(--tg-theme-text-color);\n}\n\n.layer-group-label {\n  flex: 1;\n  text-align: left;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.layer-group-label-count {\n  font-size: 14px;\n  opacity: 0.7;\n  font-weight: normal;\n}\n\n.layer-drag-handle {\n  cursor: grab;\n  user-select: none;\n  color: rgba(138, 138, 138, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 26px;\n  touch-action: none; /* Отключаем прокрутку во время перетаскивания */\n}\n\n.layer-drag-handle:active {\n  cursor: grabbing;\n}\n\n.layer-row.in-group {\n  margin-left: 15px;\n  width: calc(100% - 15px);\n}\n\n/* Стили для удаленных элементов */\n.layer-row.deleted, .layer-group-row.deleted {\n  opacity: 0.6;\n  background-color: rgba(255, 100, 100, 0.1);\n  border: 1px dashed rgba(255, 100, 100, 0.3);\n}\n\n.layer-row.deleted:hover, .layer-group-row.deleted:hover {\n  background-color: rgba(255, 100, 100, 0.2);\n  opacity: 0.8;\n}\n\n/* Стили для зоны удаления */\n.delete-zone {\n  transition: background-color 0.2s ease, opacity 0.2s ease;\n}\n\n.delete-zone.active {\n  transform: scale(1.1);\n  box-shadow: 0 0 10px rgba(255, 68, 68, 0.5);\n}\n\n/* Стили для области разгруппировки */\n.ungroup-drop-zone {\n  box-sizing: border-box;\n  width: 100%;\n  height: 10px; /* Половина высоты обычного слоя */\n  border: 2px dashed rgba(138, 138, 138, 0.4);\n  border-radius: 8px;\n  background-color: rgba(138, 138, 138, 0.08);\n  color: var(--tg-theme-hint-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  opacity: 0;\n}\n\n.ungroup-drop-zone.active {\n  border: 2px dashed var(--tg-theme-button-color);\n  background-color: rgba(var(--tg-theme-button-color-rgb, 138, 138, 138), 0.15);\n  color: var(--tg-theme-button-color);\n  opacity: 1;\n  height: 22px; \n}\n\n.ungroup-zone-text {\n  font-size: 11px;\n  font-weight: 500;\n  user-select: none;\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
